import type {IntBoolean} from '@myparcel/sdk';
import type {CarrierId, CarrierName, ValueOf} from '@myparcel-frontend/types';

export interface CarrierOption {
  api_key: string;
  carrier: {
    id: ValueOf<typeof CarrierId>;
    name: ValueOf<typeof CarrierName>;
  };
  carrier_id: ValueOf<typeof CarrierId>;
  enabled: IntBoolean;
  id: number;
  optional: IntBoolean;
  options?: CarrierOptionsOptions;
  password: string;
  primary: IntBoolean;
  type: ContractType;
  username: string;
  subscription_id?: number;
  label?: string;
}

export interface UpdateCarrierOption {
  carrier_id: ValueOf<typeof CarrierId>;
  username?: string;
  password?: string;
  api_key?: string;
  options?: CarrierOptionsOptions;
}

export const ContractType = {
  MAIN: 'main',
  CUSTOM: 'custom',
} as const;

export interface ShopCarrierOptions {
  [shopId: number]: CarrierOption[];
}

type CarrierOptionsOptions =
  PostNlOptions | DhlOptions | DpdOptions | BpostOptions | UpsOptions | CheapCargoOptions | BrtOptions | [];

interface PostNlOptions {
  barcodeOptions?: {
    gpRange: string;
    gpType: string;
  };
  customerCode?: string;
  customerCollectionLocation?: string;
  customerNumber?: string;
  serviceLevels?: number;
}

interface DhlOptions {
  accountNumbers?: string[];
}

export interface DpdOptions {
  sendingDepot?: string;
}

interface BpostOptions {
  passphrase?: string;
  trackingChannel?: {
    password: string;
  };
}

interface UpsOptions {
  customerNumber?: string;
}

interface CheapCargoOptions {
  package_types?: number[];
}

interface BrtOptions {
  customerNumber: string;
  departureDepot?: string;
}
